import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import PlacesAutocomplete, {geocodeByAddress} from 'react-places-autocomplete';
import GoogleMapReact from 'google-map-react';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import arrayMove from 'array-move';

// import {Redirect, Link} from 'react-router-dom';
import {PostData} from '../apis/fbsapi';

import Header from './Header';
import LightboxMessage from './LightboxMessage';
import LoadingSpinner from './LoadingSpinner';
// import Sidebar from './Sidebar';

// var geocoder, map, google;

const AnyReactComponent = ({ text }) => <div className='map_pointer'><i className="fas fa-map-marker-alt"></i></div>;

const SortableItem = SortableElement(({index,image,deleteFunction}) => {
    let background_image_styles = {
        backgroundImage: `url(${image})`
    };
    return (
        <div className="listing_image" style={background_image_styles} draggable>
            <div className="delete_image" onClick={()=>deleteFunction(index)}>
                <i className="far fa-times-circle"></i>
            </div>
        </div>
    );
});

const SortableList = SortableContainer(({items,deleteFunction}) => {
  return (
    <div className="sort_container">
      {items.map((value, index) => (
        <SortableItem key={`item-${index}`} index={index} image={value.image} deleteFunction={deleteFunction}/>
      ))}
    </div>
  );
});

class NewListing extends Component {

    constructor(){
        super();
        this.state = {
            address:'',
            geo_address: '',
            images:[],
            price:'',
            home_type:'',
            parcel_id:'',
            bedrooms:'',
            bathrooms:'',
            sq_ft:'',
            lot_size:'',
            year_built:'',
            status:'',
            description:'',
            error_type:'',
            error_message:'',
            show_loading:false,
            loading_message:'',
        };
        this.submit_property = this.submit_property.bind(this);
        this.onChange = this.onChange.bind(this);
        this.hideLightboxMessage = this.hideLightboxMessage.bind(this);
        this.fileUpload = this.fileUpload.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
    }

    handleChange = address => {
        this.setState({ address });
    };

    handleSelect = address => {
        this.setState({ 
            address, 
            addressSearch: address
        });
        this.geocodeAddress(address);
    }

    handleAddressButtonClick = e => {
        e.preventDefault();
        this.setState({
            addressSearch: this.state.address
        });
        this.geocodeAddress(this.state.address);
    }

    geocodeAddress(address) {
        this.setState({
            geo_address: '',
        }, () => {
            geocodeByAddress(address)
            .then(results => this.setState({
                geo_address:results[0],
            }) )
            .catch(error => console.error('Error', error));
        });
    }

    renderMap(){
        if(this.state.geo_address){

            // console.log(this.state.geo_address.geometry.location.lat());
            // console.log(this.state.geo_address.geometry.location.lng());

            return(

                <div className="map_wrap">
                    <GoogleMapReact
                    bootstrapURLKeys={{ key: "AIzaSyB_q0EJQbRCuuh7Uk57nuzew2LdRA6FhLk" }}
                    defaultCenter={{
                        lat: this.state.geo_address.geometry.location.lat(),
                        lng: this.state.geo_address.geometry.location.lng()
                      }}
                    defaultZoom={12}
                    
                    >
                    {/* <div lat={this.state.geo_address.geometry.location.lat()} lng={this.state.geo_address.geometry.location.lng()} text={'Kreyser Avrora'} ></div> */}

                        <AnyReactComponent
                            lat={this.state.geo_address.geometry.location.lat()}
                            lng={this.state.geo_address.geometry.location.lng()}
                            text={''}
                        />
                    </GoogleMapReact>
                </div>
            );

            // let mapSrc="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q="+encodeURIComponent(this.state.addressSearch)+"&amp;spn=0.369101,0.585022&amp;z=14&amp;iwloc=A&amp;output=embed";
           
        }else{
            return(
                <div className="map_holder">

                </div>
            )
        }
    }

    submit_property(e) {
        e.preventDefault();

            var post_data=this.state;
            post_data.user=sessionStorage.getItem('user');

            this.setState({
                show_loading:true,
                loading_message:"Saving your listing..."
            });
            
            PostData('new_listing',post_data).then((result) => {
                let responseJson = result;
                if(responseJson.type==="invalid_token"){
                    sessionStorage.removeItem("user");
                    window.location="/?login_required";
                }else if(responseJson.type==="error"){
                    this.setState({
                        error_type:responseJson.type,
                        error_message:responseJson.message,
                        show_loading:false
                    });
                }else{
                    window.location="/dashboard?property_added";
                }

            });
    }

    onChange(e){
        this.setState({[e.target.name]:e.target.value});
    }

    hideLightboxMessage(){
        this.setState({
            error_type:'',
            error_message:'',
        })
    }

    fileUpload(e){
        let files = Array.from(e.target.files);
        if(files.length){
            files.forEach((file, i) => {

                let this_state=this;

                var reader = new FileReader();
                reader.onload=function(event){
                    this_state.setState({
                        images:this_state.state.images.concat(event.target.result)
                    });
                }
                reader.readAsDataURL(file);
            });
        }
    }

    renderImages=()=>{
        if(this.state.images.length){
            console.log(this.state.images);
            return (
                <div>
                    <span className="image_instructions">Drag and drop the images below to reorder them. The first image will be the featured image for the listing.</span>
                    <SortableList items={this.state.images} onSortEnd={this.onSortEnd} axis="xy" deleteFunction={this.deleteImage}/>
                </div>
            );
        }else{
            return (<span className="no_image_message">Click the button below to upload listing images.</span>);
        }
    }

    deleteImage=(index)=>{
        let new_array=this.state.images.slice(0, index).concat(this.state.images.slice(index + 1, this.state.images.length))
        this.setState({
            images:new_array
        });
    }

    onSortEnd=({oldIndex,newIndex})=>{
        this.setState({
            images: arrayMove(this.state.images, oldIndex, newIndex),
        });
    };

    render() {
        return (
            <div className="dashboard_wrap">

                <LightboxMessage message={this.state.error_message} type={this.state.error_type} close_lightbox={this.hideLightboxMessage}></LightboxMessage>

                <LoadingSpinner show_loading={this.state.show_loading} loading_message={this.state.loading_message}></LoadingSpinner>
                
                <Header />
                {/* <Sidebar /> */}
                <div className="dashboard_content">
                    
                    <h2 className="page_title"><i className="fa fa-plus-circle"></i> Create New Listing  
                        <Link to="/dashboard" className="button">
                            Cancel
                        </Link>
                    </h2>

                    <form className="new_listing_form fbs_form" onSubmit={this.submit_property}>
                        {/* <input type="text" name="address" placeholder="Enter your listing address"/> */}

                        <PlacesAutocomplete
                            value={this.state.address}
                            onChange={this.handleChange}
                            onSelect={this.handleSelect}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div className="address_search_wrap">
                                <input
                                {...getInputProps({
                                    placeholder: 'Enter your listing address',
                                    className: 'location-search-input',
                                })}
                                />
                                <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map(suggestion => {
                                    const className = suggestion.active
                                    ? 'suggestion-item--active'
                                    : 'suggestion-item';
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                    ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                    : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                    return (
                                    <div
                                        {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                        })}
                                    >
                                        <span>{suggestion.description}</span>
                                    </div>
                                    );
                                })}
                                </div>
                            </div>
                            )}
                        </PlacesAutocomplete>

                        <button className="address_search_button button green" onClick={this.handleAddressButtonClick}>
                            <i className="fa fa-search"></i>Search
                        </button>

                        {this.renderMap()}

                        <div className="form_section">

                            <h3><i className="fa fa-images"></i> Listing Images</h3>

                            <div className="images_holder">
                                {this.renderImages()}
                                <div className="clear"></div>
                            </div>

                            <label htmlFor="image_upload" className="button"><i className="fa fa-upload"></i> Upload Image</label>
                            <input type="file" name="images" onChange={this.fileUpload} multiple id="image_upload"/>

                        </div>

                        <div className="form_section">
                            <h3><i className="fa fa-list-ul"></i> Property Information</h3>

                            <div className="element_wrap one_third row_first">
                                <label>Price</label>
                                <input type="number" placeholder="Price" name="price" onChange={this.onChange}/>
                            </div>

                            <div className="element_wrap one_third">
                                <label>Home Type</label>
                                <select name="home_type" onChange={this.onChange}>
                                    <option value=""></option>
                                    <option value="single_family">Single Family</option>
                                    <option value="condo">Condo</option>
                                    <option value="townhouse">Townhouse</option>
                                    <option value="multi_family">Multi Family</option>
                                    <option value="apartment">Apartment</option>
                                    <option value="mobile_manufactured">Mobile/Manufactured</option>
                                    <option value="coop_unit">Coop Unit</option>
                                    <option value="vacant_land">Vacant Land</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>

                            <div className="element_wrap one_third">
                                <label>Parcel ID</label>
                                <input type="number" placeholder="Parcel ID" name="parcel_id" onChange={this.onChange}/>
                            </div>
                            
                            <div className="element_wrap one_third row_first">
                                <label>Bedrooms</label>
                                <input type="number" placeholder="Number of Bedrooms" name="bedrooms" onChange={this.onChange}/>
                            </div>

                            <div className="element_wrap one_third">
                                <label>Bathrooms</label>
                                <input type="number" placeholder="Number of Bathrooms" name="bathrooms" onChange={this.onChange}/>
                            </div>

                            <div className="element_wrap one_third">
                                <label>Finished Square Feet</label>
                                <input type="number" placeholder="Square Footage" name="sq_ft" onChange={this.onChange}/>
                            </div>

                            <div className="element_wrap one_third row_first">
                                <label>Lot Size (sq. ft.)</label>
                                <input type="number" placeholder="Lot Size" name="lot_size" onChange={this.onChange}/>
                            </div>

                            <div className="element_wrap one_third">
                                <label>Year Built</label>
                                <input type="number" placeholder="Year Built" name="year_built" onChange={this.onChange}/>
                            </div>

                            <div className="element_wrap one_third">
                                <label>Status</label>
                                <select name="status" onChange={this.onChange}>
                                    <option value=""></option>
                                    <option value="for_sale">For Sale</option>
                                    <option value="sold">Sold</option>
                                    <option value="sale_pending">Sale Pending</option>
                                    <option value="coming_soon">Coming Soon</option>
                                </select>
                            </div>

                            <div className="element_wrap">
                                <label>Description</label>
                                <textarea name="description" className="description" onChange={this.onChange}></textarea>
                            </div>
                        
                        </div>

                        <button type="submit" className="button green"><i className="fa fa-check"></i> Save Listing</button>

                    </form>

                </div>
            </div>
        );
    }
}
export default NewListing;